import React from 'react';
import initApp from './app';

let app = initApp();

if(module.hot) {
  let rawState = {};
  module.hot.addStatusHandler(status => {
    if(status !== 'ready') return;
    rawState = app.store.toJS();
  });
  module.hot.accept([
    './app'
  ], function() {
    app = initApp(rawState);
  });
}